import { render, staticRenderFns } from "./LoaderMango.vue?vue&type=template&id=1b8ce51c&scoped=true&"
import script from "./LoaderMango.vue?vue&type=script&lang=js&"
export * from "./LoaderMango.vue?vue&type=script&lang=js&"
import style0 from "./LoaderMango.vue?vue&type=style&index=0&id=1b8ce51c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ce51c",
  null
  
)

export default component.exports